import NativeLazyImage from "./NativeLazyImage";
import "./../styles/testimonial_slide.style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons";

export default function TestimonialSlide({
  avatar,
  author,
  designation,
  desc,
}) {
  return (
    <div className="card testimonial-slide border-0 p-4 mb-4 mx-2">
      <span className="_quote">
        <FontAwesomeIcon icon={faQuoteLeft} />
      </span>
      <div className="_desc mt-3">{desc}</div>

      <div className="d-flex mt-3">
        <div className="_avtar_wrap me-3">
          <NativeLazyImage
            src={avatar}
            alt={`${author} avatar`}
            classes="card-img-top"
          />
        </div>
        <div className="">
          <h4 className="card-title mb-0">{author}</h4>
          <p className="card-desig mb-0">{designation}</p>
        </div>
      </div>
    </div>
  );
}
